import { CardBody, Form, FormGroup, Input, Label, TabContent, TabPane } from "reactstrap";
import { borderData } from "../../../Data/UiKitsData/TabsData";
import { TabDatatype } from "../../../Types/UiKitsType";

import UserProfiles from "../../Apps/Users/UserProfiles";
import AttendanceMe from "../Attendance/AttendanceMe";
import MTPApprovals from "./MTPApprovals";
import LeaveApprovals from "./LeaveApprovals";
import ExpenseApprovals from "./ExpenseApprovals";
import PODApprovals from "./PODApprovals";
import PODSummary from "./PODSummary";
import SupportApprovals from "./SupportApprovals";
import ClosingStockApprovals from "./ClosingStockApprovals";
import HolidayApprovals from "./HolidayApprovals";
import GeoFencingApprovals from "./GeoFencingApprovals";

export default function ApprovalTabContent({ tabId }: { tabId: string }) {
    return (
        <TabContent activeTab={tabId}>
            <TabPane className={`fade ${tabId === '1' ? 'show' : ''}`} tabId="1">
                {tabId === '1' && <MTPApprovals />}
            </TabPane>
            <TabPane className={`fade ${tabId === '2' ? 'show' : ''}`} tabId="2">
                {tabId === '2' && <LeaveApprovals />}
            </TabPane>
            <TabPane className={`fade ${tabId === '3' ? 'show' : ''}`} tabId="3">
                {tabId === '3' && <ExpenseApprovals />}
            </TabPane>
            <TabPane className={`fade ${tabId === '4' ? 'show' : ''}`} tabId="4">
                {tabId === '4' && <PODApprovals />}
            </TabPane>
            <TabPane className={`fade ${tabId === '5' ? 'show' : ''}`} tabId="5">
                {tabId === '5' && <PODSummary />}
            </TabPane>
            <TabPane className={`fade ${tabId === '6' ? 'show' : ''}`} tabId="6">
                {tabId === '6' && <SupportApprovals />}
            </TabPane>
            <TabPane className={`fade ${tabId === '7' ? 'show' : ''}`} tabId="7">
                {tabId === '7' && <ClosingStockApprovals />}
            </TabPane>
            <TabPane className={`fade ${tabId === '8' ? 'show' : ''}`} tabId="8">
                {tabId === '8' && <HolidayApprovals />}
            </TabPane>
            <TabPane className={`fade ${tabId === '9' ? 'show' : ''}`} tabId="9">
                {tabId === '9' && <GeoFencingApprovals />}
            </TabPane>
        </TabContent>
    );
}
